import styled from "styled-components";

export const FurnitureSetWrapper = styled.div<{
  height?: string;
  width?: string;
}>`
  width: ${(props) => props.width ?? "53px"};
  height: ${(props) => props.height ?? "53px"};
  background: var(--grey100);
  display: flex;
  align-items: center;
  justify-content: center;
`;
